'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_FormQuantity$$anon$3(toUnderlying$3) {
  this.aBu = null;
  this.aBu = toUnderlying$3;
}
export { $c_Lapp_data_FormQuantity$$anon$3 as $c_Lapp_data_FormQuantity$$anon$3 };
$p = $c_Lapp_data_FormQuantity$$anon$3.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity$$anon$3;
/** @constructor */
function $h_Lapp_data_FormQuantity$$anon$3() {
}
export { $h_Lapp_data_FormQuantity$$anon$3 as $h_Lapp_data_FormQuantity$$anon$3 };
$h_Lapp_data_FormQuantity$$anon$3.prototype = $p;
$p.bYF = (function(wrapper) {
  return this.aBu.ak(wrapper.gy);
});
$p.ak = (function(src) {
  return this.bYF(src);
});
var $d_Lapp_data_FormQuantity$$anon$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity$$anon$3, "app.data.FormQuantity$$anon$3", ({
  DF: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_FormQuantity$$anon$3 as $d_Lapp_data_FormQuantity$$anon$3 };
//# sourceMappingURL=app.data.-Form-Quantity$$anon$3.js.map
